import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { Pipeline } from 'app/modules/projects/projects.types';
import { ProjectType, PropertyType, ProjectStage, InvestmentType, Vehicle } from 'app/core/models/account.types';
import { AccountService } from 'app/core';
import { User } from 'app/core/models/user.types';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';
import { filter } from 'rxjs';

@Component({
  selector: 'projects-filter',
  templateUrl: './projects-filter.component.html',
  styleUrls: ['./projects-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectsFilterComponent extends OnDestroyMixin implements OnInit {
  filterForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  pipelines: Pipeline[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  vehicles: Vehicle[];
  investmentTypes: InvestmentType[];
  users: User[];

  savedFilter: any = null;

  public isMapView: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectsFilterComponent>,
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _accountService: AccountService,
    private readonly confirmService: ConfirmService,
  ) {
    super();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.filterForm = this._formBuilder.group({
      propertyTypeIdIn: [''],
      projectTypeIdIn: [''],
      vehicleIdIn: [''],
      assignedUserIdIn: [''],
      investmentTypeIdIn: [''],
      projectStageIdIn: [''],
      pipelineIdIn: [],
      period: ['last_30_days'],
    });

    this.projectTypes = this.data.data.options.project_types.filter((option) => !option.hidden);
    this.propertyTypes = this.data.data.options.property_types.filter((option) => !option.hidden);
    this.projectStages = this.data.data.options.project_stages.filter((option) => !option.hidden);
    this.pipelines = this.data.data.options.pipelines.filter((pipeline) => pipeline?.pipeline_type != 'dynamic');
    this.investmentTypes = this.data.data.options.investment_types.filter((option) => !option.hidden);
    this.vehicles = this.data.data.options.vehicles.filter((option) => !option.hidden);
    this.users = this.data.data.options.users;
    this.isMapView = this.data.isMapView;

    if (this.data.filters) {
      this.filterForm.patchValue(this.data.filters);
    }

    if (this.data.savedFilter) {
      this.savedFilter = this.data.savedFilter;
    } else {
      this.savedFilter = { name: '' };
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  clearAndDiscard(): void {
    let filters = { period: 'last_30_days' };
    this.matDialogRef.close({ filters: filters });
  }

  deleteSavedFilter(): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((res: boolean) => res))
      .subscribe(() => {
        this._accountService
          .deleteFilter(this.savedFilter.id)
          .pipe(untilComponentDestroyed(this))
          .subscribe(() => {
            this.matDialogRef.close();
          });
      });
  }

  /**
   * Send the message
   */
  save(): void {
    let filters = this.filterForm.value;
    this.matDialogRef.close({ filters: filters });
  }
}
